
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tourType]/[slug]",
      function () {
        return require("private-next-pages/[tourType]/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tourType]/[slug]"])
      });
    }
  